import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-aos": "fade-left",
  class: "col-md-2 col-4 card-container"
}
const _hoisted_2 = ["src", "alt"]

import {ref, watch} from 'vue';
import {useStore} from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'SkillCard',
  props: {
  iconName: String,
  name: String,
  addImagePadding: Boolean,
  addRadius: Boolean,
},
  setup(__props) {



const store = useStore();
const isDarkMode = ref(store.state.isDarkMode);

watch(
  () => store.state.isDarkMode,
  newValue => {
    isDarkMode.value = newValue;
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["wrapper d-flex flex-column centered", {
        light: !isDarkMode.value,
      }])
    }, [
      _createElementVNode("img", {
        src: 
          require(`../../assets/skill/${__props.iconName ?? __props.name?.toLowerCase()}.webp`)
        ,
        alt: __props.iconName ?? __props.name?.toLowerCase(),
        class: _normalizeClass(["image", {
          'image-padding': __props.addImagePadding,
          'image-radius': __props.addRadius,
        }])
      }, null, 10, _hoisted_2),
      _createElementVNode("p", null, _toDisplayString(__props.name), 1)
    ], 2)
  ]))
}
}

})